import React, { FC } from "react";

import ScheduleDetail from "./../../components/Schedule/ScheduleDetail";

const ScheduleDetailPage: FC = () => <ScheduleDetail />;

export default ScheduleDetailPage;
